<div class="pt-3 pb-5 toolkit">
  <app-section-container [isCarausalAvailable]="true">
    <app-section-heading>
      <span class="text__black"> Toolkits </span>
    </app-section-heading>
    <div>
      <app-section-description>
        <span class="text__black">
          {{ description }}
        </span>
      </app-section-description>
    </div>
    <div
      class="d-flex align-items-center justify-content-md-center justify-content-start gap-2 py-3 toolkit-chip"
    >
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === categoryTypes.trending,
        }"
        (click)="selectedCategory = categoryTypes.trending; fetchToolkits()"
        title="Trending"
      >
        <app-card-chips
          ><span ngProjectAs="[chip-icon]">
            @if (selectedCategory === categoryTypes.trending) {
              <img
                src="images/trending.svg"
                height="24"
                width="24"
                alt="trending"
              />
            } @else {
              <img
                src="images/trending-black.svg"
                height="24"
                width="24"
                alt="trending"
              />
            }</span
          >Trending</app-card-chips
        >
      </div>
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === categoryTypes.new,
        }"
        (click)="selectedCategory = categoryTypes.new; fetchToolkits()"
        title="New on AIKosh"
      >
        <app-card-chips>
          <span ngProjectAs="[chip-icon]">
            @if (selectedCategory === categoryTypes.new) {
              <img src="images/star-white.svg" height="24" width="25" alt="" />
            } @else {
              <img src="images/star.svg" height="24" width="25" alt="star" />
            }
          </span>
          New on IndiaAI
        </app-card-chips>
      </div>
      <div class="horizontal-line"></div>
      <div
        class="view-all"
        [routerLink]="['/', routes.home, routes.toolkit, routes.all]"
        title="View All"
      >
        <app-card-chips>
          <img src="images/view-all.svg" height="24" width="25" alt="vie-all" />
          View All
        </app-card-chips>
      </div>
    </div>
    <div class="position-relative pt-5">
      <button
        [ngStyle]="{ visibility: !toolkits?.length ? 'hidden' : 'visible' }"
        class="d-flex align-items-center justify-content-center position-absolute toolkit-carousel-arrow toolkit-carousel-arrow--prev"
      >
        <img
          src="images/prev-arrow.svg"
          height="14"
          width="10"
          alt="prev arrow"
        />
      </button>

      <div
        class="d-flex align-items-center justify-content-center gap-3"
        [ngClass]="isToolkitsLoading ? 'd-block' : 'd-none'"
      >
        <app-card-skeleton-loader
          [cardType]="CardType.toolkit"
        ></app-card-skeleton-loader>
        <div class="d-none d-sm-block">
          <app-card-skeleton-loader
            [cardType]="CardType.toolkit"
          ></app-card-skeleton-loader>
        </div>
        <div class="d-none d-md-block">
          <app-card-skeleton-loader
            [cardType]="CardType.toolkit"
          ></app-card-skeleton-loader>
        </div>
        <div class="d-none d-md-block">
          <app-card-skeleton-loader
            [cardType]="CardType.toolkit"
          ></app-card-skeleton-loader>
        </div>
      </div>

      <div [ngClass]="!isToolkitsLoading ? 'swiper-section d-block' : 'd-none'">
        <swiper-container
          #swiperContainerToolkits
          id="toolkit-swiper-container"
          init="false"
        >
          @for (toolkit of toolkits; track toolkit) {
            <swiper-slide>
              <div class="toolkit-carousel h-100">
                <app-toolkit-card
                  [toolkitListItem]="toolkit"
                  (onVoteButtonClicked)="fetchToolkits()"
                ></app-toolkit-card>
              </div>
            </swiper-slide>
          }
        </swiper-container>

        <ng-container *ngIf="!toolkits?.length">
          <ng-container *ngIf="isErrorFetchingToolkits; else noRecordFound">
            <app-couldnt-load-data
              minHeight="25rem"
              (onRetry)="fetchToolkits()"
            ></app-couldnt-load-data>
          </ng-container>

          <ng-template #noRecordFound>
            <app-no-record-found></app-no-record-found>
          </ng-template>
        </ng-container>
      </div>
      <button
        [ngStyle]="{ visibility: !toolkits?.length ? 'hidden' : 'visible' }"
        class="d-flex align-items-center justify-content-center position-absolute toolkit-carousel-arrow toolkit-carousel-arrow--next"
      >
        <img width="10" height="14" src="images/next-arrow.svg" alt="Next" />
      </button>
      <div class="toolkit-swiper-pagination swiper-pagination"></div>
    </div>
  </app-section-container>
</div>
